import React, { useState, useEffect } from "react";
import { InputNumber, Select, Space, Button } from "antd";

const { Option } = Select;

const OperatorExpressionInput = ({ value, onChange }) => {
  const initialOperations = Array.isArray(value) ? value : [];

  const [operations, setOperations] = useState(initialOperations);

  useEffect(() => {
    setOperations(Array.isArray(value) ? value : []);
  }, [value]);

  const triggerChange = (changedOperations) => {
    if (onChange) {
      onChange(changedOperations);
    }
  };

  const handleOperatorChange = (index, op) => {
    const newOps = [...operations];
    newOps[index].operator = op;
    setOperations(newOps);
    triggerChange(newOps);
  };

  const handleConstantChange = (index, constant) => {
    const newOps = [...operations];
    newOps[index].constant = constant;
    setOperations(newOps);
    triggerChange(newOps);
  };

  const addOperation = () => {
    const newOps = [...operations, { operator: "+", constant: 0 }];
    setOperations(newOps);
    triggerChange(newOps);
  };

  const removeOperation = (index) => {
    const newOps = operations.filter((_, i) => i !== index);
    setOperations(newOps);
    triggerChange(newOps);
  };

  return (
    <div>
      {operations.length === 0 && (
        <div style={{ marginBottom: 8 }}>
          <Button onClick={addOperation}>Add Operation</Button>
        </div>
      )}
      {operations.map((op, index) => (
        <Space key={index} style={{ marginBottom: 8 }}>
          <Select
            value={op.operator}
            onChange={(val) => handleOperatorChange(index, val)}
            style={{ width: 80 }}
          >
            <Option value="+">+</Option>
            <Option value="-">-</Option>
            <Option value="*">*</Option>
            <Option value="/">/</Option>
          </Select>
          <InputNumber
            value={op.constant}
            onChange={(val) => handleConstantChange(index, val)}
            placeholder="Constant"
          />
          <Button onClick={() => removeOperation(index)} type="link">
            Remove
          </Button>
          <Button onClick={addOperation} type="link">
            Add
          </Button>
        </Space>
      ))}
    </div>
  );
};

export default OperatorExpressionInput;
